// Attributes for the text control of a field that holds a secret

/**
 * Keeps a secret away from the tools that read the text of a field. The enhanced spellcheck of
 * Chrome and Edge, and grammar extensions such as Grammarly, send that text to a remote service,
 * and mobile keyboards capitalize a revealed password as it is typed.
 *
 * autocorrect is left out on purpose: Vue sets it as a DOM property, which is a boolean in the
 * browsers that support it, so "off" would turn it on.
 */
export const SECRET_TEXT_ATTRS = Object.freeze({
    spellcheck: "false",
    autocapitalize: "off",
    "data-gramm": "false",
});

function preventDefault(e: Event) {
    e.preventDefault();
}

/**
 * The attributes above, plus the listeners that keep an editable secret inside its field: it
 * cannot be copied, cut or dragged out. Selecting is left alone, because editing needs it, and so
 * is pasting. Bind it with v-bind on the control, or on TextAreaField, which hands it on.
 *
 * Not for a secret shown so the user can take it, such as a token just created.
 */
export const SECRET_FIELD_ATTRS = Object.freeze({
    ...SECRET_TEXT_ATTRS,
    onCopy: preventDefault,
    onCut: preventDefault,
    onDragstart: preventDefault,
});
